import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Form from "../../../components/Form";
import DynamicFormRenderer from "../../../components/DynamicFormRenderer";
import { kennemerlandFormConfig } from "./formConfig";
import Api from "../../../Api";


// Styling from 
const templateStyles = {
  formHeader: {
    fontSize: "1.6em",
    margin: "10px 0 20px 0",
    color: "#003366",
  },
  introBox: {
    background: "#f3fbf9",
    border: "1px solid #d7f2ea",
    borderRadius: "10px",
    padding: "16px 18px",
    marginBottom: "22px",
    lineHeight: "1.4",
    textAlign: "start"
  },
  sectionTitle: {
    marginTop: "26px",
    marginBottom: "10px",
    fontSize: "1.15em",
    color: "#1abc9c !important",
  },
  formLabel: {
    fontWeight: "bold",
    marginBottom: "6px",
    display: "block",
    color: "#1f2d3d",
  },
  formControl: {
    width: "100%",
    borderRadius: "6px",
    padding: "10px 12px",
    border: "1px solid #ced4da",
    boxSizing: "border-box",
    background: "#fff",
  },
  button: {
    padding: "11px 28px",
    fontSize: "1rem",
    borderRadius: "6px",
    border: "none",
    background: "#1abc9c",
    color: "#fff",
    cursor: "pointer",
  },
};

const KennemerlandAanmeldformulier = (props) => {
  const { metadata: { brandColors } } = kennemerlandFormConfig
  const [loading, setLoading] = useState(false);
  const [showModalSucces, setShowModalSucces] = useState(false);
  const [showModalError, setShowModalError] = useState(false);

  // Initialize react-hook-form
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    unregister,
    reset,
    control
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {},
    shouldFocusError: true,
    criteriaMode: 'all'
  });

  const submitForm = async (data) => {
    try {
      setLoading(true);

      await Api.dossiers.Create({
        defDossier: kennemerlandFormConfig.metadata.defDossier,
        ...data
      },
        kennemerlandFormConfig.metadata.apiUsername,
        kennemerlandFormConfig.metadata.apiKey);

      setLoading(false);
      setShowModalSucces(true);
    } catch (error) {
      setLoading(false);
      setShowModalError(true);
    }
  };

  return (
    <>
      <style jsx>{`
        .form-input:focus {
          outline: none;
          border-color: ${brandColors.primary};
          box-shadow: 0 0 0 3px rgba(26, 188, 156, 0.1);
          transform: translateY(-1px);
        }

        .form-textarea:focus {
          outline: none;
          border-color: ${brandColors.primary};
          box-shadow: 0 0 0 3px rgba(26, 188, 156, 0.1);
          transform: translateY(-1px);
        }

        .animate-fade-in {
          animation: fadeIn 0.3s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-slide-up {
          animation: slideUp 0.2s ease-out;
        }

        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        .section-enter {
          animation: sectionEnter 0.4s ease-out;
        }

        @keyframes sectionEnter {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .progress-bar {
          transition: width 0.3s ease-out;
        }

        .form-field-enter {
          animation: fieldEnter 0.3s ease-out;
        }

        @keyframes fieldEnter {
          from {
            opacity: 0;
            transform: translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .tooltip {
          position: relative;
        }

        .tooltip::before,
        .tooltip::after {
          position: absolute;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.2s ease-in-out;
          z-index: 1000;
        }

        .tooltip::before {
          content: attr(data-tooltip);
          background: #1f2937;
          color: white;
          font-size: 12px;
          line-height: 1.4;
          padding: 8px 12px;
          border-radius: 6px;
          white-space: nowrap;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%) translateY(-4px);
        }

        .tooltip::after {
          content: "";
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid #1f2937;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
        }

        .tooltip:hover::before,
        .tooltip:hover::after {
          opacity: 1;
        }
      `}</style>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
          <div className="relative">
            <div className="h-16 w-16 rounded-full border-4 animate-spin" style={{ borderColor: brandColors.border, borderTopColor: brandColors.primary }}></div>
            <div className="absolute inset-0 h-16 w-16 rounded-full border-4 border-transparent animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.8s', borderTopColor: brandColors.primaryLight }}></div>
          </div>
        </div>
      )}
      {showModalError && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" onClick={() => setShowModalError(false)}></div>
            <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-6 pt-6 pb-4">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">Foutmelding</h3>
                  <button
                    onClick={() => setShowModalError(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                  <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                </div>
                <p className="text-lg font-medium text-gray-900 mb-6 text-center">
                  Er is een probleem opgetreden bij het verzenden van de gegevens.
                </p>
                <div className="flex justify-center">
                  <button
                    onClick={() => setShowModalError(false)}
                    className="px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold rounded-lg hover:from-red-600 hover:to-red-700 focus:outline-none focus:ring-4 focus:ring-red-200 transition-all duration-200"
                  >
                    Opnieuw proberen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModalSucces && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" onClick={() => setShowModalSucces(false)}></div>
            <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-6 pt-6 pb-4">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">Aanmelding verzonden</h3>
                  <button
                    onClick={() => setShowModalSucces(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-4" style={{ backgroundColor: `${brandColors.primary}20` }}>
                  <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: brandColors.primary }}>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p className="text-lg font-medium text-gray-900 mb-6 text-center">
                  Jouw aanmelding is succesvol verzonden.
                </p>
                <div className="flex justify-center">
                  <button
                    onClick={() => {
                      setShowModalSucces(false);
                      reset();
                    }}
                    className="px-6 py-3 text-white font-semibold rounded-lg focus:outline-none transition-all duration-200 inline-block text-center"
                    style={{
                      background: `linear-gradient(135deg, ${brandColors.primary} 0%, ${brandColors.primaryDark} 100%)`
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = `linear-gradient(135deg, ${brandColors.primaryDark} 0%, ${brandColors.primary} 100%)`;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = `linear-gradient(135deg, ${brandColors.primary} 0%, ${brandColors.primaryDark} 100%)`;
                    }}
                  >
                    Afsluiten
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="pt-10 min-h-screen bg-gradient-to-br from-slate-50 to-gray-100 py-8 px-4 sm:px-6 lg:px-8" role="main" aria-labelledby="form-title">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
              Aanmeldformulier Zorg & Veiligheidshuis Kennemerland
            </h1>
            <p className="text-lg text-gray-600" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
              Vul hier de aanmeldgegevens in
            </p>
          </div>

          <div style={templateStyles.introBox}>
            <h4 style={{ color: brandColors.primary, fontWeight: 500 }}>Belangrijk om te weten</h4>
            <p>
              Elke ketenpartner kan een casus inbrengen. In de wekelijkse weegploeg bekijken de procescoördinatoren
              of een aanmelding past binnen de doelstellingen (dit is nog geen inhoudelijk casusoverleg).
            </p>
            <p>
              De casus moet voldoen aan de 3 criteria:
              (A) problemen op 3+ leefgebieden, (B) verbinding tussen meerdere ketens nodig,
              (C) reguliere interventies eerder onvoldoende resultaat.
            </p>
            <p className="subtle">
              Vul dit formulier a.u.b. zo volledig mogelijk in.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="px-8 py-6" style={{ background: `linear-gradient(135deg, ${brandColors.primary} 0%, ${brandColors.primaryDark} 100%)` }}>
              <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
                <div className="text-white">
                  <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>Zorg & Veiligheidshuis Kennemerland</h2>
                </div>
              </div>
            </div>

            <Form
              className="p-8 lg:p-12 animate-fade-in"
              {...props}
              register={register}
              handleSubmit={handleSubmit}
              setValue={setValue}
              unregister={unregister}
              formState={{ errors }}
              onSubmit={submitForm}
              defDossier={kennemerlandFormConfig.metadata.defDossier}
              reset={reset}
              apiUsername={kennemerlandFormConfig.metadata.apiUsername}
              apiKey={kennemerlandFormConfig.metadata.apiKey}
            >

              {/* Dynamic Form Renderer */}
              <DynamicFormRenderer
                config={kennemerlandFormConfig}
                register={register}
                errors={errors}
                setValue={setValue}
                unregister={unregister}
                control={control}
                watch={watch}
                className="animate-fade-in"
              />
              <p className="text-start text-sm text-gray-500 mt-4">
                NB: Indien wordt besloten tot een Individueel Casus Overleg (ICO) ontvangt de betrokkene hierover schriftelijk bericht vanuit het Zorg & Veiligheidshuis, tenzij er een gegronde reden is dit achterwege te laten.
              </p>
            </Form>

          </div>
        </div>
      </div>
    </>
  );
};

export default KennemerlandAanmeldformulier;